var React = require('react');

function PlaybuttonFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.6562 7L0.627679 13.9282L0.62768 0.0717965L10.6562 7Z","fill":"black"}));
}

PlaybuttonFilled.defaultProps = {"viewBox":"0 0 11 14","fill":"none"};

module.exports = PlaybuttonFilled;

PlaybuttonFilled.default = PlaybuttonFilled;
